<div>
  <div mat-card-title>Table Status</div>
  <div>
    <div style="overflow-x: auto; height:auto" class="mb-2 d-flex justify-content-center  flex-wrap">
      @for (item of sections; track item; let i = $index) {
        <div>
          <div class="text-center">
            <p class="text-weight">{{item.name}}</p>
          </div>
          <div class="chart-container pt-3" >
            <canvas class="tbl-fixed" id="chart-{{i}}"></canvas>
          </div>
        </div>
      }
    </div>
  </div>
</div>
